var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.btns),function(item,key){return [(item.value)?_c('li',{key:key,on:{"click":function($event){return _vm.footerClick(item)}}},[_vm._v("\n      "+_vm._s(item.text || _vm.btnText[item.value])+"\n    ")]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c115295a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/main/components/footerBtn.vue
// module id = null
// module chunks = 